var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('usergroups',{attrs:{"usergroups":_vm.userGroups},on:{"userGroupChange":function($event){return _vm.getUserGroups()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }